<template>
  <div
    class="card-item options-api"
    :class="{
      'card-item-search': smallCards && !cardSizeReorder,
      'card-item-reorder': smallCards && cardSizeReorder,
      mb0: isOnCartPage,
    }"
    ref="productCard"
    v-if="!isOnCartPage || (quantity > 0 && isValid) || !isValid"
  >
    <div
      class="card-wrap"
      :class="{
        w100:
          clientPlatform == 'Web' &&
          (isOnCartPage || smallCards) &&
          !cardSizeReorder,
        'border-none': isLastInvalidItem,
        'd-flex justify-content-between card-wrap-cart': isOnCartPage,
        'variant-no-padding': variantNoPadding,
      }"
    >
      <div
        class="card-size"
        :class="{
          'card-rounded': cardRounded,
        }"
        v-if="!hideProductImg && !cardSizeReorder"
      >
        <div class="c-img-wrap">
          <div v-if="(smallCards || dataHorizontalCarousel) && !isOnCartPage">
            <lazy-image
              class="card-img img-product-home"
              :class="{ 'grayscale-100': outOfStock }"
              alt="default image"
              :src="imageSrc"
              :src-placeholder="getPlaceHolderImg"
              loading="lazy"
              @click="
                smallCards && !isOnCartPage
                  ? $emit('updateShowProductCardInModal')
                  : ''
              "
              @error="handleImageError"
            />
            <img
              v-if="smallCards && !isOnCartPage"
              :src="[
                isVeg
                  ? staticImgBaseUrl + '/images/global/tag-veg.svg'
                  : staticImgBaseUrl + '/images/global/tag-non-veg.svg',
              ]"
              class="mr8 veg-nogveg"
              loading="lazy"
              @error="handleImageError"
              alt="default image"
            />
          </div>
          <div v-else class="p-card">
            <product-card-carousel
              :img-array="imageArray"
              :productId="productId"
            ></product-card-carousel>
          </div>
        </div>

        <div class="card-content">
          <div class="at-top" v-if="!smallCards">
            <div class="pt16" v-if="!isInModal">
              <div
                class="tag-wrap tag-blue"
                :style="getValueTagBgStyle"
                v-if="valueTag"
              >
                <span class="tag color-white">{{ valueTag }}</span>
                <div class="triangle-b-left" :style="getValueTagTipStyle"></div>
              </div>
            </div>

            <div class="d-flex align-items-center" :class="{ pt8: !valueTag }">
              <div v-if="socialTag" class="pr42">
                <div class="border-radius-4" :style="getSocialTagStyles">
                  <span class="tag color-white fw-700">{{ socialTag }}</span>
                </div>
              </div>
              <div
                class="fav-wrap dt-hand"
                @click.stop="$emit('updateFavourite')"
                v-if="!isFavourite"
              >
                <img
                  :src="staticImgBaseUrl + '/images/global/heart.svg'"
                  alt="heart image"
                />
                <!-- <i class="hkfi-favourite-icon"></i> -->
              </div>
              <div
                class="fav-lottie"
                @click.stop="$emit('updateFavourite')"
                v-else
              >
                <VueLottiePlayer
                  name="confettiAnim"
                  :animationData="require(`../assets/fav_interaction.json`)"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card-size"
        :class="{
          'card-rounded': cardRounded,
          'card-size-reorder': cardSizeReorder,
        }"
        v-else-if="!hideProductImg && cardSizeReorder"
      >
        <div
          class="c-img-wrap"
          :style="{
            backgroundImage: `url('${imageSrc}')`,
            backgroundSize: 'contain',
          }"
        ></div>
        <img
          :src="[
            isVeg
              ? staticImgBaseUrl + '/images/global/tag-veg.svg'
              : staticImgBaseUrl + '/images/global/tag-non-veg.svg',
          ]"
          class="mr8 veg-nogveg"
          v-if="cardSizeReorder"
          loading="lazy"
          @error="handleImageError"
          alt="default image"
        />
      </div>

      <div
        class="at-botm flex-column jcsb"
        :class="{
          'card-botm-gradient': !smallCards,
          pl0: hideProductImg,
          'at-botm-cart': isOnCartPage,
        }"
      >
        <!-- extra info -->
        <div class="extra-info">
          <!-- modal for customization -->

          <!-- modal tobe shown, if quantity > 0 and then clicked on customisation btn -->

          <!-- customization disbale button modal -->

          <!-- modal tobe shown, if quantity > 0 and then clicked on Add/Minus Cta btn -->
        </div>

        <!-- item title and desc -->
        <div class="product-info">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <i
                class="mt3"
                :class="[
                  isVeg ? 'tag-veg' : 'tag-non-veg',
                  smallCards ? 'mr5' : 'size-16 mr5',
                ]"
                v-if="!cardSizeReorder && (!smallCards || isOnCartPage)"
              ></i>
              <span
                class="popular-menu-header medium fw-700"
                :class="{
                  'fs-14': smallCards,
                  'fs-16': !smallCards,
                }"
                >{{ displayName }}</span
              >
            </div>
            <div v-if="productRating && !smallCards && !isOnCartPage">
              <i class="hkfi-rating-star"></i>
              <span class="fs-12 ml4">{{ productRating }}</span>
            </div>
          </div>
          <!-- <h3 :class="showFullInfo? 'product-desc-info-popup lh18':'product-desc lh18'"> -->
          <span
            class="bg-yellow pl10 pr10 br4 fs-10"
            v-if="outOfStock && !isOnCartPage"
            >Out of Stock</span
          >
          <h3
            v-if="!isOnCartPage"
            class="product-desc lh16"
            :class="{ 'product-full-desc': isInModal }"
          >
            {{ description }}
          </h3>
          <h3 v-if="productAttributes?.length" class="color-slaty fs-11 pl19">
            <span>{{ productAttributes?.[1]?.value }}</span
            ><span
              v-if="
                productAttributes?.[1]?.value && productAttributes?.[0]?.value
              "
            >
              |
            </span>
            <span>{{ productAttributes?.[0]?.value }}</span>
          </h3>
          <!-- edit flow for customizable non combo item -->
          <div
            class="combo-items-info pl19"
            v-if="
              smallCards &&
              !isComboItem &&
              isCustomizable &&
              isOnCartPage &&
              !outOfStock
            "
          >
            <div>
              <span
                class="color-teal-primary fs-11 hand d-flex edit-text fw-800"
                @click="$emit('updateCartCustItem')"
                >Edit
                <!-- <i
                  class="hkfi-arrow-line rotate90clockwise pl15 arrow-address fs-10"
                ></i> -->
              </span>
            </div>
          </div>
          <!-- combo specific ui, will only be shown for combo item AND smallCards prop is true -->
          <div
            class="combo-items-info pl19"
            v-if="smallCards && isComboItem && isOnCartPage"
          >
            <!-- this will repeat -->
            <ul
              class="fs-11 lh18"
              :class="[outOfStock ? 'color-grey-light' : 'color-slaty']"
              v-for="(
                comboVariantName, comboVariantNameIndex
              ) in selectedComboVariants"
              :key="comboVariantNameIndex"
            >
              <li
                :class="[
                  outOfStock ||
                  outOfStockComboVariants.includes(comboVariantName)
                    ? 'color-grey-light'
                    : 'color-slaty',
                ]"
              >
                <div class="d-flex justify-content-between">
                  <span
                    :class="{
                      'opacity-60':
                        outOfStockComboVariants.includes(comboVariantName),
                    }"
                    >1pc - {{ comboVariantName }}
                  </span>
                  <span
                    v-if="
                      outOfStockComboVariants.includes(comboVariantName) &&
                      !isOnCartPage
                    "
                    class="bg-yellow plr7 br4 fs-9 color-slaty-dark"
                    >Out of Stock</span
                  >
                </div>
              </li>
            </ul>
          </div>

          <!-- <div>
              <button
                class="remove-invalid-items d-flex bold pl24"
                @click="showComboDetails()"
                v-if="isOnCartPage && isComboItem"
              >
                {{ showOrHideDetailsText }}
                <i
                  class="hkfi-arrow-line pl16"
                  :class="[
                    showDetails
                      ? 'rotate90antiClockwise arrow-address-btm'
                      : 'rotate90clockwise arrow-address',
                  ]"
                ></i>
              </button>
            </div> -->

          <div v-if="smallCards && isComboItem && isOnCartPage && !outOfStock">
            <span
              class="color-teal-primary fs-11 hand pl19 d-flex edit-text"
              :class="[outOfStock ? 'disabled' : '']"
              @click="$emit('updateCartCustItem')"
              >Edit
              <!-- <i
                class="hkfi-arrow-line rotate90clockwise pl15 arrow-address fs-10"
              ></i -->
              ></span
            >
          </div>
        </div>

        <!-- flavour tags code -->
        <div
          class="d-flex gap6 pt8"
          v-if="flavourTagsArray?.length && !smallCards"
        >
          <div
            v-for="(flavour, i) in flavourTagsArray"
            :key="i"
            class="flavour-tags"
          >
            <div class="flavour-tag" :style="getFlavourTagStyle(flavour)">
              {{ flavour?.[0] }}
            </div>
          </div>
        </div>

        <div
          v-if="
            !flavourTagsArray?.length &&
            (dataHorizontalCarousel || clientPlatform == 'Web')
          "
          class="flavour-tags-space"
        ></div>

        <!-- product price and Add cta -->
        <div class="selected-info" v-if="!outOfStock && !isOnCartPage">
          <div class="selections disp-col-inline">
            <div
              v-if="currentPrice === 0 || !currentPrice"
              class="width10 hide-shimmer-text shimmer-container rounded"
            >
              price
            </div>
            <div v-else>
              <div class="product-price disp-col-inline">
                <div class="fw-700" :class="smallCards ? 'fs-14' : 'fs-16'">
                  <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
                  <span>
                    {{ currentPrice }}
                  </span>
                </div>

                <div class="strk-top tr" v-if="currentPrice !== regularPrice">
                  <span
                    class="color-grey normal"
                    :class="smallCards ? 'fs-12' : 'fs-14'"
                  >
                    <i class="rs">Rs.</i
                    ><span class="strike-diagonal-price">
                      {{ regularPrice }}
                    </span>
                  </span>
                </div>

                <div
                  class="savings"
                  v-if="currentPrice !== regularPrice && !smallCards"
                >
                  <span>SAVE</span>
                  <span class="fs-12 normal">
                    <i class="rs">Rs.</i
                    ><span class="fw-700">
                      {{ parseFloat((regularPrice - currentPrice).toFixed(2)) }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="main-cta">
            <div v-if="quantity > 0" class="btn cta-edit medium">
              <span
                class="anim-ico-minus item-status-anim"
                @click="$emit('removefromcart')"
                v-ripple
              >
              </span>
              <span class="item-quantity">{{ quantity }}</span>
              <span
                class="anim-ico-plus item-status-anim"
                @click="!outOfStock && $emit('addtocart')"
                v-ripple
              ></span>
            </div>

            <button
              v-if="quantity === 0 && !outOfStock"
              class="btn medium bold hand cta-add secondary"
              @click="$emit('addtocart')"
              v-ripple
            >
              Add
              <!-- <span class="anim-ico-plus item-status-anim"></span> -->
            </button>
            <!-- for small cards only -->
            <div
              v-if="isCustomizable && smallCards && !isOnCartPage"
              class="cust-text mt5 ml0 color-grey"
              @click="$emit('addtocart')"
              v-ripple
            >
              {{ isComboItem ? "Customisable" : `${customizations} Options` }}
            </div>

            <!-- v-if="isCustomizable && !smallCards" -->
            <div
              v-if="isCustomizable && !smallCards && !isOnCartPage"
              class="cust-text flex-row justify-content-center"
              @click="$emit('addtocart')"
              v-ripple
            >
              {{ isComboItem ? "Customisable" : `${customizations} Options` }}
            </div>
          </div>
        </div>
      </div>

      <!-- product price and Add cta -->
      <div
        class="selected-info no-margin flex-column align-items-flex-end"
        v-if="!outOfStock && isOnCartPage"
      >
        <div class="main-cta" v-if="currentPrice != 'Free'">
          <div
            v-if="quantity > 0"
            class="btn cta-edit medium"
            :class="{
              'cta-edit-cart': isOnCartPage,
            }"
          >
            <span
              class="anim-ico-minus item-status-anim"
              @click="$emit('removefromcart')"
              v-ripple
            >
            </span>
            <span class="item-quantity">{{ quantity }}</span>
            <span
              class="anim-ico-plus item-status-anim"
              @click="!outOfStock && $emit('addtocart')"
              v-ripple
            ></span>
          </div>

          <button
            v-if="quantity === 0 && !outOfStock"
            class="btn medium bold hand cta-add secondary"
            @click="$emit('addtocart')"
            v-ripple
          >
            Add
            <!-- <span
              class="anim-ico-plus item-status-anim"
              v-if="!smallCards"
            ></span> -->
          </button>
          <!-- for small cards only -->
          <div
            v-if="isCustomizable && smallCards && !isOnCartPage"
            class="cust-text mt5 ml0 color-grey"
            @click="$emit('addtocart')"
            v-ripple
          >
            {{ isComboItem ? "Customisable" : `${customizations} Options` }}
          </div>
        </div>
        <div class="selections pt8">
          <div
            v-if="currentPrice === 0 || !currentPrice"
            class="width10 hide-shimmer-text shimmer-container rounded"
          >
            price
          </div>
          <div
            v-else-if="
              (discountedPrice === currentPrice || !discountedPrice) &&
              !discount
            "
            :class="{ 'd-flex gap4': smallCards }"
          >
            <div
              v-if="regularPrice && currentPrice !== regularPrice"
              class="tr"
            >
              <span class="color-grey fs-10">
                <i class="rs">Rs.</i
                ><span class="strike-diagonal-price"> {{ regularPrice }} </span>
              </span>
            </div>
            <div class="product-price">
              <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
              <span :class="{ 'color-error': currentPrice == 'Free' }">
                {{ currentPrice }}
              </span>
            </div>
          </div>
          <div v-else :class="{ 'd-flex gap4': smallCards }">
            <div
              v-if="currentPrice && currentPrice !== discountedPrice"
              class="tr"
            >
              <span class="color-grey fs-10">
                <i class="rs">Rs.</i
                ><span class="strike-diagonal-price"> {{ currentPrice }} </span>
              </span>
            </div>
            <div class="product-price">
              <i class="rs" v-if="discountedPrice != 'Free'">Rs.</i>
              <span :class="{ 'color-error': discountedPrice == 'Free' }">
                {{ discountedPrice }}
              </span>
            </div>
          </div>

          <!-- v-if="isCustomizable && !smallCards" -->
          <div
            v-if="isCustomizable && !smallCards && !isOnCartPage"
            class="cust-text"
            @click="$emit('addtocart')"
            v-ripple
          >
            {{ isComboItem ? "Customisable" : `${customizations} Options` }}
          </div>
        </div>

        <div class="savings mt8" v-if="regularPrice !== discountedPrice">
          <span class="fs-10 normal">
            <i class="rs">Rs.</i
            ><span class="fw-700">
              {{ parseFloat((regularPrice - discountedPrice).toFixed(2)) }}
            </span>
          </span>
          <span class="fs-10 fw-700">
            {{ isOnCartPage ? "SAVED" : "SAVE" }}</span
          >
        </div>
      </div>
      <div class="customizations border-bottom-light hide">
        <span class="-base">Added:&nbsp;</span>
        <span class="color-grey"> cheese, chilly </span>
        <span class="color-base">Replaced:&nbsp;</span>
        <span class="color-grey"> cheese </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import ProductCardCarousel from "./ProductCardCarousel.vue";
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
export default {
  name: "ProductCardTemplate",
  props: {
    smallCards: { required: true, default: false },
    isValid: { required: false, default: true },
    isOnCartPage: { required: false, default: false },
    showIconWithTitle: { required: false, default: false },
    quantity: { required: true, default: 0 },
    cardRounded: { required: false, default: false },
    cardSizeReorder: { required: false, default: false },
    hideProductImg: { required: false, default: false },
    imageSrc: { required: true, default: "" },
    isInModal: { required: false, default: false },
    isFavourite: { required: false, default: false },
    isVeg: { required: false, default: true },
    displayName: { required: true, default: "" },
    description: { required: false, default: "" },
    isComboItem: { required: false, default: false },
    currentPrice: { required: true, default: 0 },
    regularPrice: { required: false, default: 0 },
    isCustomizable: { required: false, default: false },
    customizations: { required: false, default: 0 },
    productId: { required: false, default: "" },
    isProductInfoClickable: { required: false, default: false },
    showFullInfo: { required: false, default: false },
    selectedComboVariants: { required: false, default: [] },
    outOfStockComboVariants: { required: false, default: [] },
    bestsellerTag: { required: false, default: false },
    newTag: { required: false, default: false },
    outOfStock: { required: false, default: false },
    isLastInvalidItem: { required: false, default: false },
    savingAmt: { required: false, default: 0 },
    discountedPrice: { required: false, default: 0 },
    discount: { required: false, default: 0 },
    productAttributes: { required: false, default: [] },
    variantNoPadding: { required: false, default: false },
    dataModuleProps: { required: false, default: [] },
    metaData: { required: false, default: {} },
    imageArray: { required: false, default: [] },
    productRating: { required: false, default: "" },
    dataHorizontalCarousel: { required: false, default: false },
  },
  components: {
    ProductCardCarousel,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      clientPlatform,
      interval: 0,
      isAutoScrollEnabled: true,
      socialTagBg: "rgba(0, 0, 0, 0.30)",
      flavourTagColor: "#666",
      flavourTagBg: "#F3F3F3",
    };
  },
  mounted() {
    this.updateStateWithModuleProps();
  },
  methods: {
    updateStateWithModuleProps() {
      if (this.dataModuleProps?.length) {
        this.socialTagBg = this.dataModuleProps?.socialTagBg;
        this.flavourTagColor = this.dataModuleProps?.flavourTagColor;
        this.flavourTagBg = this.dataModuleProps?.flavourTagBg;
        this.isAutoScrollEnabled = Utility.tryJsonParse(
          this.dataModuleProps?.isAutoScrollEnabled,
        );
      }
    },
    handleImageError(event) {
      event.target.src =
        staticImgBaseUrl + "/images/global/PlaceholderImage.png";
      event.target.onerror = null;
    },
    getFlavourTagStyle(flavour) {
      return {
        color: flavour?.[1] || this.flavourTagColor,
        background: flavour?.[2] || this.flavourTagBg,
      };
    },
  },
  computed: {
    getPlaceHolderImg() {
      return this.staticImgBaseUrl + "/images/global/PlaceholderImage.png";
    },
    getSocialTagStyles() {
      return {
        background: this.socialTagBg,
      };
    },
    getValueTagTipStyle() {
      return {
        borderColor: `transparent transparent transparent ${this.valueTagTipColor}`,
      };
    },
    getValueTagBgStyle() {
      return {
        background: `linear-gradient(119deg, ${this.valueTagBgColor[0]} 7.81%,  ${this.valueTagBgColor[1]} 95.11%)`,
      };
    },
    flavourTagsArray() {
      return (
        this.flavourTags?.length && this.flavourTags.map((x) => x.split("|"))
      );
    },
    valueTagBgColor() {
      return (
        (this.metaData?.value_tag_bgColor?.values?.length &&
          this.metaData?.value_tag_bgColor?.values) ||
        this.dataModuleProps?.valueTagBgColor || ["#911987", "#FE9040"]
      );
    },
    valueTagTipColor() {
      return this.metaData?.value_tag_bgTipColor?.values || "#D90F06";
    },
    socialTag() {
      return this.metaData?.social_tag?.values[0];
    },
    valueTag() {
      return this.metaData?.value_tag?.values[0];
    },
    flavourTags() {
      return this.metaData?.flavour_tag?.values;
    },
  },
};
</script>

<style scoped></style>
